import { createFileRoute } from '@tanstack/react-router';

import { JournalCreate } from '@/module/Journal/JournalCreate';

export const Route = createFileRoute('/_auth/journal/_journal/create')({
  component: RouteComponent,
  staticData: {
    pageTitle: { id: 'pageTitle.create' },
  },
});

function RouteComponent() {
  return <JournalCreate />;
}
